/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAgentsBaseRequest } from '../../models/get-agents-base-request';
import { GetAgentsResponse } from '../../models/get-agents-response';

export interface PostApiAgentV1$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The request payload containing filter and pagination options.
     */
    body?: GetAgentsBaseRequest
}

export function postApiAgentV1$Plain(http: HttpClient, rootUrl: string, params?: PostApiAgentV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentsResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiAgentV1$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAgentsResponse>;
    })
  );
}

postApiAgentV1$Plain.PATH = '/private/v1/agents';
